<template>
 <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="采集URL" prop="gatherUrl">
          <el-input v-model="dataForm.gatherUrl" placeholder="采集URL"></el-input>
      </el-form-item>
          <el-form-item label="从第几页开始采" prop="pageStart">
          <el-input v-model="dataForm.pageStart" placeholder="从第几页开始采"></el-input>
      </el-form-item>
          <el-form-item label="采到第几页" prop="pageEnd">
          <el-input v-model="dataForm.pageEnd" placeholder="采到第几页"></el-input>
      </el-form-item>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>

      <el-button type="primary" :disabled="dataForm.sysTask== 1" @click="all()">{{btn}}</el-button>
      <!-- <el-button type="primary" @click="one()">采集单本</el-button> -->
      </el-form>

</template>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      visible: false,
      url: '',
      adUrl: '',
      appLogo: '',
      btn: '采集全部',
      dataForm: {
        id: '',
        gatherUrl: '',
        pageStart: '',
        pageEnd: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {

      }
    }
  },
  created(){
    this.init ()
    this.url = `${process.env.VUE_APP_API_TARGET}${process.env.VUE_APP_BASE_API}/sys/oss/upload?token=${Cookies.get('token')}`

  },
  methods: {
    init () {
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.getInfo()
      })
    },
     // 上传之前
     beforeUploadHandle (file) {

       return true;
   },
       // 上传成功
   successHandle (res, file) {
     if(res.code == 0){
       this.adUrl = res.data.src,
       this.dataForm.adUrl = res.data.src
     }else{
       return this.$message.error(res.msg)
     }
   },
   // 上传之前
   beforeUploadHandleLogo (file) {

       return true;
   },
       // 上传成功
   successHandleLogo (res, file) {
     if(res.code == 0){
       this.appLogo = res.data.src,
       this.dataForm.appLogo = res.data.src
     }else{
       return this.$message.error(res.msg)
     }
   },
    // 获取信息
    getInfo () {
      this.$http.get(`/novelconfig/novelconfig/getInfo`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        if(this.dataForm.sysTask == 1){
          this.btn = '采集中'
        }
      }).catch(() => {})
    },
    all(){
      this.$http.get(`/novelconfig/novelconfig/all`).then(({ data: res }) => {
        if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
          message: '卖力采集中',
          type: 'success'
        });
        this.getInfo()
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/novelconfig/novelconfig/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style>
  .input-item{
    width: 400px;
  }
</style>
